module.exports = __webpack_public_path__ + "static/elephant5-289403d354410d3c42dfea4efbc53ab1.jpeg";